import React from 'react'

function TenderTextWindow() {
  return (
    <embed src="\pdfs\EAT1.2.5_FSG_Window_air_curtain_unit_kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextWindow